import { isConditionFilled } from './Condition/helper';

// Find parameters not existing in the db, but template repository
export const getMissingParamFieldNames = (conditions: CustomConditions, parameterData?: UseGetParametersResponse) => {
    // edge case: when the user creates a new rule, there's only one condition with
    // parameterField.name = []. In that case, return an empty array
    if (!conditions[0].parameterField.name[0]) {
        return [];
    }

    const filledConditions = conditions.filter((cond) => isConditionFilled(cond));

    // 1. create a hahsmap based off condition parameters, 1 = exist, 0 = not exist
    const paramCheckMap: {
        [fieldName: string]: number;
    } = {};

    filledConditions.forEach((cond) => {
        const condParamFieldName = cond.parameterField.name[0];

        if (parameterData?.fieldNameHashmap[condParamFieldName]) {
            paramCheckMap[condParamFieldName] = 1;
        } else {
            paramCheckMap[condParamFieldName] = 0;
        }
    });

    // 2. iterate paramCheckMap and get parameters that don't exist in the db
    const missingParamFieldNames: string[] = [];
    Object.keys(paramCheckMap).forEach((fieldName) => {
        if (!paramCheckMap[fieldName]) {
            missingParamFieldNames.push(fieldName);
        }
    });

    return missingParamFieldNames;
};
